import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	title: {
		'id': 'home.title',
		'defaultMessage': 'Grow Smarter. Go Stog.',
	},
	subtitle: {
		'id': 'home.subtitle',
		'defaultMessage': 'Stog is a resource efficient</br>AI augmented platform for aeroponic farming.',
	},
	buttonBuy:{
		'id': 'home.buy',
		'defaultMessage':'Buy'
	},
	buttonRent:{
		'id': 'home.rent',
		'defaultMessage':'Rent'
	}
});


// WEBPACK FOOTER //
// ./src/components/LandingHome/messages.js